import { InjectionToken } from '@angular/core';

import { ClientPath } from '@shared/models/client-path.enum';

export const CLIENT_PATH = new InjectionToken<ClientPath>('client path');
